// extracted by mini-css-extract-plugin
export default {"MenuItemsContainer":"MenuItems_MenuItemsContainer__rTbJR"};